import { PropsWithChildren } from "react";

import { Modal as MantineModal, type ModalSize, Text } from "~/ui";

const defaultModalSize = "md";

export const ModalTitle = (props: PropsWithChildren) => (
  <Text fw={500} fz="lg">
    {props.children}
  </Text>
);

interface ModalProps {
  active: boolean;
  title: string;
  onClose: () => void;
  size?: ModalSize;
}
export const Modal = ({ size = defaultModalSize, ...props }: PropsWithChildren<ModalProps>) => (
  <MantineModal centered opened={props.active} size={size} title={<ModalTitle>{props.title}</ModalTitle>} onClose={props.onClose}>
    {props.children}
  </MantineModal>
);
